import { Appointment } from "../../../api/appointment.types";
import { AppointmentsMainAction } from "./appointments.main.types";

export const appointmentsMainRequestAction = (params: { medic_user_id: number }): AppointmentsMainAction => ({ type: 'APPOINTMENTS_MAIN_REQUEST', params })

export const appointmentsMainSuccessAction = (appointments: Appointment[]): AppointmentsMainAction => ({ type: 'APPOINTMENTS_MAIN_SUCCESS', params: appointments })

export const appointmentsMainFailureAction = (error?: any): AppointmentsMainAction => ({ type: 'APPOINTMENTS_MAIN_FAILURE' })